// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3KF_P","form":"styles_form__wQ-jx"};